<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back" :disabled="backButtonStatus"/>
          <action-button  @click="create" icon="new" bold :text="lang.button_Create" :tooltip="lang.button_Create" :disabled="createButtonStatus"/>

          



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left" :title="lang.button_Left" :disabled="false"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right" :title="lang.button_Right" :disabled="false"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
import ActionBar from "@/components/shared/ActionBar";
import ActionButton from "@/components/shared/ActionButton";
import ActionContent from "@/components/shared/ActionContent";
import ActionPanel from "@/components/shared/ActionPanel";
import { mapGetters } from 'vuex'

import Content from "@/components/ProjectManager/Views/ProjectNew/Middle/Content/Content";

export default {
  name: "Middle",
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props: {
    lang: Object
  },
  data() {
    return {
      createButtonStatus: false,
      backButtonStatus: false,
      saving: false
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      

    }),
  },
  created() {},
  methods: {
    create() {
      

      let vue = this;
      let trig = false;
      for (
        let i = 0, lei = this.$store.getters.propertyToSaving.length;
        i < lei;
        i++
      ) {
        if (
          this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true &&
          this.$store.getters.propertyToSaving[i].value == "" &&
          this.$store.getters.propertyToSaving[i].type != "project number"
        ) {
          trig = true;
          break;
        }
      }

      if (trig == true) {
        let obj = {
          text: this.lang.alert_error_new_project_required,
          time: 15,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);
      } else {
        let obj = {
          categoryId: this.$store.getters.selectedTreeProjectItemObject
            .categoryId,
          values: this.$store.getters.propertyToSaving,
          distributorPartId: ""
        };

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewProject",obj)
          .then(function(result) {
            if (result.status == "OK") {
              //let revisionId = result.data;

              vue.saving = true;

              let obj = {
                text: vue.lang.alert_success_new_project,
                time: 5,
                type: "success"
              };

              vue.$store.dispatch("displayFooterAlert", obj);

              vue.toDetails(result.data);

              const reloadObj = {
                status: true,
                name: "DataTableFilteredOnApiProjComponent",
                source: ""
              };
              vue.$store.dispatch("reloadAfterAction", reloadObj);

              

              
            } else {
              let obj = {
                text: vue.lang.alert_error_new_project + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }
          });
      }
    },
    toDetails(_goalObj) {
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/ProjectManager/ProjectDetails";

      console.log(_goalObj)

      //temporary:
      const goalObj = {
        revisionId: _goalObj.revisionId,
        id: _goalObj.projectId,
        userId: this.currentUser.userId,
        revision: 1
      }

      let type = "pending";

      const obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          userId: goalObj.userId,
          value: {
            display: goalObj.revisionId
          }
        },
        col___revision: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: goalObj.revision
          }
        },
        col___status: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: "pending"
          }

        },
        col___name: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }

        },
        col___image: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___projectType: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        }
      }

      this.$store.dispatch("setSelectedRows", obj);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);



      

      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });


    },
    back() {
      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving) {
        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiProjComponent"
        };
        this.$store.dispatch("reloadAfterAction", reloadObj);
      }

      let to = this.$route.query.from;


      

      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel() {
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
    },
    toggleLeftPanel() {
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
    }
  }
};
</script>


<style scoped>
.middle {
  border-right: 1px solid #666;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectNew/Middle/Middle.vue